import { Component, Element, Fragment, Host, Listen, Prop, h } from '@stencil/core';
import { formatHREF } from '../../utils/utils';

@Component({
  tag: 'cradlepoint-nav-lang',
  styleUrl: 'nav-lang.css',
  shadow: true,
})
export class NavLang {
  @Element() host: HTMLElement;

  @Prop() domain : string = 'cradlepoint.com';
  @Prop() json   : string;

  jsonData = {
    title: 'Discover Cradlepoint near you',
    description: "We have dedicated teams in regions the world over. We're here to answer your questions and connect you with the perfect Wireless WAN solution for your unique business needs. ",
    "background-image": 'https://img.cradlepoint.com/auto-mapping-folder/2021/02/world-map-dotted.png',
    columns: [{}],
    additional_details: '',
    excluded_slugs: '',
    slugs: ''
  };

  async componentWillLoad() {
    if (this.json) {
      return fetch(this.json)
        .then(response => response.json())
        .then(data => {
          let bgImage: string;

          if (data.intl_background_image) {
            bgImage = data.intl_background_image;
            bgImage.startsWith('/wp-content/uploads') && (bgImage = bgImage.replace('/wp-content/uploads', 'https://img.cradlepoint.com/auto-mapping-folder'));
          }

          this.jsonData = {
            title: data.intl_title && data.intl_title,
            description: data.intl_description && data.intl_description,
            "background-image": bgImage && bgImage,
            columns: data.intl_column && data.intl_column,
            additional_details: data.intl_additional_details && data.intl_additional_details,
            excluded_slugs: data.intl_excluded_slugs && data.intl_excluded_slugs,
            slugs: data.intl_slugs && data.intl_slugs
          };
        })
        .catch(error => console.log(error));
    }

    return null;
  }

  hideLanguageNav = () => {
    this.host.classList.add('hidden');
    if (this.host.shadowRoot) {
      let regionTitles = this.host.shadowRoot.querySelectorAll('.region-title');
      regionTitles?.forEach((regionTitle: HTMLElement) => (regionTitle.dataset.open = 'false'));
    }
    if( document.querySelector('body #modal-backDrop') ){
      document.querySelector('body #modal-backDrop').remove();
    }
  }

  toggleRegions = (event) => {
    let target = event.target;
    if (!this.host.shadowRoot) return;
    
    let regionTitles = this.host.shadowRoot.querySelectorAll('.region-title');

    regionTitles.forEach((regionTitle: HTMLElement) => {
      regionTitle.dataset.open = 'false';
    });

    target.dataset.open = (target.dataset.open == 'false') ? 'true' : 'false';
  }

  @Listen('resize', { target: 'window' })
  handleResize() {
    clearTimeout(resizeTimeout);
    var resizeTimeout = setTimeout(() => {
      if (this.host.shadowRoot) {
        let regionTitles = this.host.shadowRoot.querySelectorAll('.region-title');
        if (window.innerWidth > 767) {
          regionTitles?.forEach((regionTitle: HTMLElement) => (regionTitle.dataset.open = 'false'));
        }
      }
    }, 100);
  }

  render() {
    return (
      this.jsonData && (
        <Host style={{
          backgroundImage: `url(${this.jsonData['background-image']})`
        }}>
          <div class="title-container">
            <button class="button-close" onClick={this.hideLanguageNav}>
              <svg class="svg-inline--fa fa-xmark" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg="">
                <path fill="currentColor" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
              </svg>
            </button>
            <h2 class="title">{this.jsonData.title}</h2>
            <p class="description">{this.jsonData.description}</p>
          </div>
          {this.jsonData.columns && (
            <div class="regions">
              {this.jsonData.columns.map((region: {column: string, module: Array<any>}) => {
                let module = region.module;
                return (
                  <div class="region-group">
                    {module.map(countries => {
                      return (
                        <div class="region">
                          <h3 class="region-title" data-open="false" onClick={this.toggleRegions}>
                            {countries.label}
                            <span>
                              <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512">
                                <path fill="currentColor" d="M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/>
                              </svg>
                            </span>
                          </h3>
                          <ul class="countries">
                            {countries.languages.map((country: { country_languages: any[]; country: any; }) => {
                              return (
                                country.country_languages && (
                                  <li class="country">
                                    <span class="country-name">{country.country}</span>
                                    <div class="languages">
                                    {country.country_languages.map((language, index) => {
                                      return <Fragment>
                                        {index !== 0 && <span>&nbsp;&mdash;&nbsp;</span>}
                                        <a
                                          href={formatHREF(this.domain, language.hreflang)}
                                          class="language"
                                          data-page-slug={language.hreflang.replace('-', '_')}
                                          data-id={language.link}
                                          data-bg=""
                                          data-hreflang={language.hreflang}
                                        >
                                          <span>{language.language}</span>
                                        </a>
                                      </Fragment>
                                    })}
                                    </div>
                                  </li>
                                )
                              )
                            })}
                          </ul>
                        </div>
                      )
                    })}
                  </div>
                )
              })}
            </div>
          )}
          {this.jsonData.additional_details && (
            <div class="additional-details">
              <div class="additional-details-inner" innerHTML={this.jsonData.additional_details}></div>
            </div>
          )}
        </Host>
      )
    );
  }

}
